import { Injectable } from '@angular/core';
import videojs from 'video.js';

@Injectable({
    providedIn: 'root'
})
export class VideoPlayerService {
    onPlay(vjs: videojs.Player): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            vjs.on("play", function () {
                resolve(true);
            });
        });
        return promise;
    }
    onPause(vjs: videojs.Player): Promise<any>{
        let promise = new Promise((resolve, reject) => {
            vjs.on("pause", function () {
                resolve(true);
            });
        });
        return promise;
    }
}